// bookingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCustomerBookings } from "../../api/bookingsApi";
import toast from "react-hot-toast";

// Thunk to fetch customer bookings
export const fetchBookingsAsync = createAsyncThunk(
  "bookings/fetchCustomerBookings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerBookings();
      // if (!response.data.status) {
      //   toast.error("Your session has expired");
      //   setTimeout(() => {
      //     window.location.replace("/");
      //     logout();
      //   }, 1500); // 1.5 seconds delay
      //   throw new Error(response.data.message);
      // }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const bookingSlice = createSlice({
  name: "bookings",
  initialState: {
    loading: false,
    bookings: [],
    error: null,
  },
  reducers: {
    resetBookingState: (state) => {
      state.loading = false;
      state.bookings = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookingsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload; // Store fetched bookings
      })
      .addCase(fetchBookingsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export const { resetBookingState } = bookingSlice.actions;
export default bookingSlice.reducer;
